import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import {formatCurrencyValue, getPricePerDayFromMonthlyRate} from "../../../../util/PaymentUtils";
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import {styled} from "@mui/material/styles";
import {LocationEquipmentType} from "../../../../types/Location";
import {hasEquipmentOverageRate} from "../../../../views/create-location-wizard/equipmentOverageRate";

const EquipmentTypePrice = styled(Typography)(() => ({
    textAlign: 'left',
}));

const EquipmentTypeSubprice = styled(Typography)(() => ({
    textAlign: 'left',
    '@media (max-width: 39.28em)': {
        fontSize: '0.8rem',
    }
}));

interface EquipmentTypeItemProps {
    asset: LocationEquipmentType;
    defaultPricePerDay: number;
    defaultPricePerMonth: number;
    defaultOverageRate?: number | null;
    showOverageColumn?: boolean;
}

const EquipmentTypeItem = (props: EquipmentTypeItemProps) => {
    const {asset, defaultPricePerDay, defaultPricePerMonth, defaultOverageRate, showOverageColumn} = props;

    const [pricePerDayInDollars, setPricePerDayInDollars] = useState<string | number | undefined>();
    const [pricePerMonthInDollars, setPricePerMonthInDollars] = useState<string | number | undefined>(defaultPricePerMonth);
    const [pricePerDayPerMonth, setPricePerDayPerMonth] = useState<string | number | undefined>();

    const {equipmentType, pricePerDay, pricePerMonth, overageRate} = asset;
    const effectiveOverageRate = [overageRate, defaultOverageRate, pricePerDay, defaultPricePerDay]
        .find(hasEquipmentOverageRate) ?? 0;

    useEffect(() => {
        const dailyPriceInCents = pricePerDay !== null && pricePerDay > 0 ? pricePerDay : defaultPricePerDay;
        const monthlyPriceInCents = pricePerMonth !== null && pricePerMonth > 0 ? pricePerMonth : defaultPricePerMonth;
        setPricePerDayInDollars(formatCurrencyValue(dailyPriceInCents));
        setPricePerMonthInDollars(formatCurrencyValue(monthlyPriceInCents));

        const pricePerDayBasedOnMonthInCents = getPricePerDayFromMonthlyRate(monthlyPriceInCents).amount;
        const pricePerDayBasedOnMonthInDollars = formatCurrencyValue(pricePerDayBasedOnMonthInCents);

        setPricePerDayPerMonth(pricePerDayBasedOnMonthInDollars)

    }, [pricePerDay, pricePerMonth, defaultPricePerDay, defaultPricePerMonth])

    return(
        <div className={`ss-location-profile-pricing-grid-item${showOverageColumn ? ' ss-location-profile-pricing-grid--overages' : ''}`}>
            <div className="ss-location-profile-pricing-type-icon-container">
                <TrackChangesIcon className="ss-location-profile-pricing-icon"/>
                <Typography variant='body1' className="ss-location-profile-pricing-row-title">
                    {equipmentType}
                </Typography>
            </div>
            <div className="ss-location-profile-pricing-subcontainer-item">
                <EquipmentTypePrice variant='body1'>
                    {pricePerDayInDollars}
                </EquipmentTypePrice>
            </div>
            <div className="ss-location-profile-pricing-subcontainer-item">
                <EquipmentTypePrice variant='body1'>
                    {pricePerMonthInDollars}
                </EquipmentTypePrice>
                <EquipmentTypeSubprice variant='body1'>
                    ({pricePerDayPerMonth}/day)
                </EquipmentTypeSubprice>
            </div>
            {showOverageColumn && (
                <div className="ss-location-profile-pricing-subcontainer-item">
                    <EquipmentTypePrice variant='body1'>
                        {effectiveOverageRate != null && effectiveOverageRate >= 0
                            ? formatCurrencyValue(effectiveOverageRate, true)
                            : '—'}
                    </EquipmentTypePrice>
                </div>
            )}
        </div>
    )
}

export default EquipmentTypeItem;
